import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/stickyMenu.js";

function StickyMenu() {
    useEffect(() => {
        window.addEventListener("scroll", () => {
            const stickyMenu = document.querySelector(".sticky-menu");

            if (window.scrollY > 160) {
                stickyMenu.classList.add("sticky");
            } else {
                stickyMenu.classList.remove("sticky");
            }
        });
    });

    return (
        <Styles>
            {/* Sticky Menu */}
            <section className="sticky-menu">
                <Container>
                    <Row>
                        <Col md="1">
                            <div className="logo">
                                <Link to={process.env.PUBLIC_URL + "/"}><img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt="" /></Link>
                            </div>
                        </Col>
                        <Col md="11">
                            <div className="menu-box d-flex justify-content-end">
                                <ul className="nav menu-nav">
                                    <li className="nav-item dropdown active">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/"} data-toggle="dropdown">Home </Link>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/about"}>About</Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/trusts"}> Trust </Link></li>
                                            <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/groups"}> Group of School </Link></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link" to={process.env.PUBLIC_URL + "/motos"}>Motto</Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/punchamukha"}> Panchamuka Shikashana </Link></li>
                                            <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/practice"}> Best Practice  </Link></li>
                                        </ul>
                                    </li>

                                    <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/facilities"}>Facilities</Link></li>
                                    <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/activities"}>Activities</Link></li>
                                    <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/registrations"}>Registration </Link></li>
                                    <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/gallery"}>Gallery </Link></li>
                                    <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/downloads"}>Download </Link></li>
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/contact"} data-toggle="dropdown">Locate Us <i className="las la-angle-down"></i></Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/alumini"}>Alumni</Link></li>
                                            <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/digital-partner"}>Digital Partner </Link></li>
                                        </ul>
                                    </li>
                                    {/* <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/"} data-toggle="dropdown">Instructor <i className="las la-angle-down"></i></Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/instructor"}>Instructors</Link></li>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/instructor-details"}>Instructor Details</Link></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/"} data-toggle="dropdown">Event <i className="las la-angle-down"></i></Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/events"}>Events</Link></li>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/event-details"}>Event Details</Link></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/"} data-toggle="dropdown">Blog <i className="las la-angle-down"></i></Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/blog-classic"}>Blog Classic</Link></li>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/blog-grid"}>Blog Grid</Link></li>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/blog-details"}>Blog Details</Link></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL + "/"} data-toggle="dropdown">Shop <i className="las la-angle-down"></i></Link>
                                        <ul className="dropdown list-unstyled">
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/products"}>Products</Link></li>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/product-details"}>Product Details</Link></li>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/cart"}>Cart</Link></li>
                                        </ul>
                                    </li> */}
                                    <li className="nav-item dropdown"><Link className="nav-link" to={process.env.PUBLIC_URL + "/topper"}>Toppers </Link></li>
                                </ul>
                                <div className="apply-btn">
                                    <Link to={process.env.PUBLIC_URL + "/admissions"}><i className="las la-clipboard-list"></i>Admission</Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default StickyMenu